import { render } from "./LeaveStatus.vue?vue&type=template&id=45761e36"
import script from "./LeaveStatus.vue?vue&type=script&lang=js"
export * from "./LeaveStatus.vue?vue&type=script&lang=js"

import "./LeaveStatus.vue?vue&type=style&index=0&id=45761e36&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__